module.exports = __webpack_public_path__ + "img/icon_anquankekao.dc0f421a.png";